import { Component } from "react";

export default class ConstantComponent<P = {}, S = {}> extends Component<P, S> {
  shouldComponentUpdate(newProps: P, newState: S) {
    return false;
  }
}
